export default "__VITE_ASSET__DB3L178Y__"